import {
  ImageWrapper,
  Title,
  EthicalLinks,
} from "./EthicalGovernanceView.styled";

interface LinkItem {
  href: string;
  text: string;
}

interface Section {
  title: string;
  links: LinkItem[];
}

const EthicalGovernanceView = () => {
  // Within the governance page we have a number of reports grouped under
  // different themes, this is an array of those themes that includes
  // the title of the section and an array of links under it
  // the links trustworthy because they're hosted by the company
  const sections: Section[] = [
    {
      title: "Sustainability progress reports",
      links: [
        {
          href: "https://lookbook.otrium.com/reports/sustainability/Impact%20Report%202024%20-%20Final%20-%20n.pdf",
          text: "Impact report 2024",
        },
        {
          href: "https://lookbook.otrium.com/files/impact-report-2023-final.pdf",
          text: "Impact report 2023",
        },
        {
          href: "https://impact.otrium.com/",
          text: "Impact report 2022",
        },
        {
          href: "https://lookbook.otrium.com/reports/sustainability/Impact-Progress-Report.pdf",
          text: "Impact report 2021",
        },
      ],
    },
    {
      title: "Fashion industry reporting",
      links: [
        {
          href: "https://lookbook.otrium.com/reports/sustainability/Otrium%20Avoided%20Impact%20Report%202023.pdf",
          text: "Fashion Impact Methodology report 2023",
        },
        {
          href: "https://impact.otrium.com/chapters/circularity/details",
          text: "Fashion Impact report 2022",
        },
        {
          href: "https://lookbook.otrium.com/Methodology-Report.pdf",
          text: "Methodology report 2022",
        },
        {
          href: "https://lookbook.otrium.com/reports/sustainability/Fashion-Impact-Report-2020.pdf",
          text: "Fashion Impact report 2021",
        },
      ],
    },
    {
      title: "Policies",
      links: [
        {
          href: "https://lookbook.otrium.com/files/environmental_policy_signed.pdf",
          text: "Environmental policy",
        },
        {
          href: "https://lookbook.otrium.com/files/furfree-policy.pdf",
          text: "Fur free policy",
        },
        {
          href: "https://lookbook.otrium.com/files/stakeholder-policy-final.pdf",
          text: "Stakeholder policy",
        },
        {
          href: "https://lookbook.otrium.com/reports/sustainability/Code-Of-Conduct.pdf",
          text: "Code of Conduct",
        },
      ],
    },
    {
      title: "Environmental impact",
      links: [
        {
          href: "https://lookbook.otrium.com/reports/sustainability/carbon+footprint+2024.pdf",
          text: "Carbon footprint report 2024",
        },
        {
          href: "https://lookbook.otrium.com/files/carbon-footprint-2023.pdf",
          text: "Carbon footprint report 2023",
        },
        {
          href: "https://lookbook.otrium.com/files/carbon-footprint-2022.pdf",
          text: "Carbon footprint report 2022",
        },
        {
          href: "https://lookbook.otrium.com/files/carbon-footprint-2021.pdf",
          text: "Carbon footprint report 2021",
        },
        {
          href: "https://lookbook.otrium.com/reports/sustainability/Carbon-Footprint-Report-2021.pdf",
          text: "Carbon footprint report 2020",
        },
      ],
    },
    {
      title: "Modern Slavery Statement",
      links: [
        {
          href: "https://lookbook.otrium.com/files/2025_modern_slavery_statement_signed.pdf",
          text: "Modern slavery statement 2024",
        },
        {
          href: "https://lookbook.otrium.com/files/2024_modern_slavery_statement_signed.pdf",
          text: "Modern slavery statement 2023",
        },
        {
          href: "https://lookbook.otrium.com/files/MSS.pdf",
          text: "Modern slavery statement 2022",
        },
      ],
    },
    {
      title: "Materiality assessment",
      links: [
        {
          href: "https://lookbook.otrium.com/files/materiality-assessment-final.pdf",
          text: "Materiality assessment 2022",
        },
      ],
    },
    {
      title: "Science Based Targets",
      links: [
        {
          href: "https://lookbook.otrium.com/files/SBTi-Press-Release.pdf",
          text: "SBTi Press Release",
        },
      ],
    },
  ];

  return (
    <div>
      <Title>Ethical governance</Title>
      <ImageWrapper>
        <img
          className="desktop"
          src="/static/images/web-ethical-governance.jpg"
          alt="Ethical governance logo"
        />
        <img
          className="mobile"
          src="/static/images/mob-ethical-governance.jpg"
          alt="Ethical governance logo"
        />
      </ImageWrapper>
      <EthicalLinks>
        {sections.map((section, index) => (
          <div key={index}>
            <div className="section-title">{section.title}</div>
            <ul>
              {section.links.map((link, linkIndex) => (
                <li key={linkIndex}>
                  <a
                    href={link.href}
                    target="_blank"
                    aria-label={`${link.text} (PDF document)`}
                  >
                    {link.text}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </EthicalLinks>
    </div>
  );
};

export default EthicalGovernanceView;
